<script>
    import Modal from './SemanticModal.svelte'

    export let active
    export let confirm = () => false
    export let wanted = "dogma remova"

    let value = null

    $: disabled = wanted !== value

    function execute() {
        value  = null
        confirm()
    }

    function cancel() {
        value  = null
        active = false
    }
</script>

<Modal {active}>
    <div class="ui tiny modal visible active">
        <div class="content">
            <div class="ui icon purple message">
                <i class="exclamation triangle icon"></i>
                <div class="content">
                    <div class="header">
                        <h2 class="ui header">
                            Atenção
                        </h2>
                    </div>
                </div>
            </div>
            <h4 class="ui header">
                Confirme se você deseja mesmo remover digitando "{wanted}" no campo abaixo
            </h4>
            <div class="ui input">
                <input type="text" bind:value placeholder={wanted}>
            </div>
        </div>
        <div class="actions">
            <button class="ui black button" on:click={cancel}>Cancelar</button>
            <button class="ui       button" class:disabled on:click={execute}>Confirmar</button>
        </div>        
    </div>
</Modal>
